class publicMessage {
  async getPublicMessages({ page }) {
    try {
      const resData = await window.axios.get('/api/v1/admin/publicmessage/all', { params: { page } });
      return resData.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async findMessageById(id) {
    try {
      const resData = await window.axios.get('/api/v1/admin/publicmessage', { params: { id } });
      return resData.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async updateMessagee(params) {
    try {
      const resData = await window.axios.put('/api/v1/admin/publicmessage', params);
      return resData.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async creatMessage(params) {
    try {
      const resData = await window.axios.post('/api/v1/admin/publicmessage', params);
      return resData.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async deleteMessage(id) {
    try {
      const res = await window.axios.delete(`/api/v1/admin/publicmessage?id=${id}`);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
}

module.exports = publicMessage;
